module.exports = __webpack_public_path__ + "assets/img/1191587028316_.pic_hd.4a201e94.jpg";